import { render, staticRenderFns } from "./act-list.vue?vue&type=template&id=ff51027a&scoped=true&"
import script from "./act-list.vue?vue&type=script&lang=js&"
export * from "./act-list.vue?vue&type=script&lang=js&"
import style0 from "./act-list.vue?vue&type=style&index=0&id=ff51027a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff51027a",
  null
  
)

export default component.exports